module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "thisism"
    }
  }, [_c('app-navigation'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ten columns offset-by-one"
  }, [_c('p', [_vm._v("\n      2010年末、｢自分達で何かしなくてはいけない｣という曖昧な危機感を覚える。そして｢ビデオカメラとMacがあるから映像をやろう｣という結論に至る。\n      またその当時、ふと手に取った本が｢～主義｣/｢～ism｣をまとめた内容であったことから｢ism｣に着想し、見栄えの良さと唯一の組み合わせを探して、｢This-ism｣転じて｢Thisism (ディスイズム)｣を活動名とする。\n      手始めに友人のニートが働くまでを撮り、荒編集した内容をYOUTUBEへ公開する。身内からの小さな反響にほくそ笑む。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      その後、ドキュメントと実験的な動画を軸に作品を作っていこうと息巻く。しかし、特に何かあるわけでもなく腐る。\n      それと同じくして｢ビデオ出来るなら何かやってよ｣という軽いノリで、少しづつバンド関連の動画を作ることが増え始める。\n      当初はバンドをやっている友達が多かったことから、持ち前のひねくれ性でバンド関連の動画は避けていたものの、話が少しずつ増えるに連れて喜びを感じ、欲求が増していく...というよりは素直になる。\n      大きく気持ちを揺り動かしてくれたのはメンバーが身近にいたA PAGE OF PUNKとTHINK AGAINの存在だったと思う。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      素直なれたので｢もっとやろう｣という思いで今に至る。\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb3c976a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thisism.vue
// module id = 92
// module chunks = 0